// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* body {
  margin: 0px;
  padding: 0px;
  font-family: "Open Sans", sans-serif;
  width: 100%;
  height: 100%;
} */

/* .bg-theme {
  background: #358696 !important;
  box-shadow: 0px 5px 5px rgb(0 0 0 / 14%);
} */

.nav-link {
  font-size: 0.85em !important;
  color: #000 !important;
}

.navbar-nav .nav-link.active,
.navbar-nav .show>.nav-link {
  color: #FFFFFF !important;
  background-color: #83A4CF;
  border-radius: 20px;
  padding: 5px 10px;
  text-align: center;
}

.orion_nav_icon {
  font-size: 14px;
}

@media (min-width: 836px) {
  .navbar-expand-sm {
    flex-wrap: nowrap;
    justify-content: flex-start;
  }
}

@media screen and (max-width: 991px) {}

@media screen and (max-width: 769px) {}

@media screen and (max-width: 420px) {}


.material-symbols-outlined {
  font-variation-settings:
    'FILL' 0,
    'wght' 400,
    'GRAD' 0,
    'opsz' 48
}

/* .fixed-header .app-main_bus {
  padding-top: 0px;
  background-color: #F2F3FC !important;
}
.app-theme-white_bus.app-container {
  background: #F2F3FC !important;
}
.img-fluid_bus{
  max-width:100%;
  overflow-y: hidden;
  overflow-x: hidden;
} */`, "",{"version":3,"sources":["webpack://./src/componets/Dashboard_Orion/LayoutMain_Orion/Header_Orion.css"],"names":[],"mappings":"AAAA;;;;;;GAMG;;AAEH;;;GAGG;;AAEH;EACE,4BAA4B;EAC5B,sBAAsB;AACxB;;AAEA;;EAEE,yBAAyB;EACzB,yBAAyB;EACzB,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE;IACE,iBAAiB;IACjB,2BAA2B;EAC7B;AACF;;AAEA,sCAAsC;;AAEtC,sCAAsC;;AAEtC,sCAAsC;;;AAGtC;EACE;;;;;AAKF;;AAEA;;;;;;;;;;;GAWG","sourcesContent":["/* body {\n  margin: 0px;\n  padding: 0px;\n  font-family: \"Open Sans\", sans-serif;\n  width: 100%;\n  height: 100%;\n} */\n\n/* .bg-theme {\n  background: #358696 !important;\n  box-shadow: 0px 5px 5px rgb(0 0 0 / 14%);\n} */\n\n.nav-link {\n  font-size: 0.85em !important;\n  color: #000 !important;\n}\n\n.navbar-nav .nav-link.active,\n.navbar-nav .show>.nav-link {\n  color: #FFFFFF !important;\n  background-color: #83A4CF;\n  border-radius: 20px;\n  padding: 5px 10px;\n  text-align: center;\n}\n\n.orion_nav_icon {\n  font-size: 14px;\n}\n\n@media (min-width: 836px) {\n  .navbar-expand-sm {\n    flex-wrap: nowrap;\n    justify-content: flex-start;\n  }\n}\n\n@media screen and (max-width: 991px) {}\n\n@media screen and (max-width: 769px) {}\n\n@media screen and (max-width: 420px) {}\n\n\n.material-symbols-outlined {\n  font-variation-settings:\n    'FILL' 0,\n    'wght' 400,\n    'GRAD' 0,\n    'opsz' 48\n}\n\n/* .fixed-header .app-main_bus {\n  padding-top: 0px;\n  background-color: #F2F3FC !important;\n}\n.app-theme-white_bus.app-container {\n  background: #F2F3FC !important;\n}\n.img-fluid_bus{\n  max-width:100%;\n  overflow-y: hidden;\n  overflow-x: hidden;\n} */"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
